// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"FootTc_TheComp__xOuOI"};